import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from "redux";
import accountReducer from "@/features/account";

export const store = configureStore({
  reducer: combineReducers({
    account: accountReducer
  })
});
